import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBIkZyo0F8xrcIzHSwoIkU26X7ycuOhQw4",
  authDomain: "pandikkadtpa.firebaseapp.com",
  projectId: "pandikkadtpa",
  storageBucket: "pandikkadtpa.firebasestorage.app",
  messagingSenderId: "520124923409",
  appId: "1:520124923409:web:b2645e7208c02508bdbbb0"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
